/**
 * WordPress dependencies
 */
import $ from 'jquery';

/** Internal Dependencies */
import { NCST } from '../';
import { ControllerComponent } from './ControllerComponent';

export default class SingleThumbnailGalleryController extends ControllerComponent {
	constructor( instanceId ) {
		super();

		this.instanceId = instanceId;

		this.state = {
			isTransitioning: false,
			currentPage: 1,
			maxPages: 3,
		};

		this.elements = {
			galleryBlock: $( '#' + this.instanceId ),
			galleryContainer: $(
				'#' + this.instanceId + ' .thumbnail-gallery__container'
			),
			galleryViewport: $(
				'#' + this.instanceId + ' .thumbnail-gallery__viewport'
			),
			pageIndicatorContainer: $(
				'#' +
					this.instanceId +
					' .thumbnail-gallery__page-indicator-container'
			),
			galleryItems: $(
				'#' + this.instanceId + ' .thumbnail-gallery__item'
			),
			galleryControls: $(
				'#' +
					this.instanceId +
					' .thumbnail-gallery__controls-container'
			),
			next: $( '#' + this.instanceId + ' .scroll.next' ),
			prev: $( '#' + this.instanceId + ' .scroll.prev' ),
			pageIndicators: $(
				'#' +
					this.instanceId +
					' .thumbnail-gallery__page-indicator-button'
			),
			pageMobileNumeralIndicator: $(
				'#' +
					this.instanceId +
					' .thumbnail-gallery__page-indicator-numerals .thumbnail-gallery__current-page'
			),
		};
	}

	init() {
		this.bindHandlers();
		NCST.elements.$win.on( 'ncst_resized', this.resetGallery.bind( this ) );
	}

	bindHandlers() {
		this.resetGallery();

		this.elements.next.on( 'click', this.handleNextClick.bind( this ) );
		this.elements.prev.on( 'click', this.handlePrevClick.bind( this ) );

		this.elements.pageIndicators.on(
			'click',
			this.handleIndicatorClick.bind( this )
		);

		this.elements.galleryContainer.on(
			'transitionend',
			this.handleTransitionEnd.bind( this )
		);
		this.elements.galleryContainer.on(
			'transitionstart',
			this.handleTransitionStart.bind( this )
		);
	}

	resetGallery() {
		let newMaxPages = this.state.maxPages;

		if ( NCST.elements.$win.width() < 830 ) {
			newMaxPages = Math.min(
				Math.ceil( this.elements.galleryItems.length / 6 ),
				5
			);
		} else if ( NCST.elements.$win.width() < 1020 ) {
			newMaxPages = Math.min(
				Math.ceil( this.elements.galleryItems.length / 8 ),
				4
			);
		} else {
			newMaxPages = Math.min(
				Math.ceil( this.elements.galleryItems.length / 10 ),
				3
			);
		}

		this.setState( {
			currentPage: 1,
			maxPages: newMaxPages,
		} );

		this.elements.pageIndicators.filter( ( index, element ) => {
			if ( $( element ).data( 'page' ) > this.state.maxPages ) {
				$( element ).parent( 'li' ).hide();
			} else {
				$( element ).parent( 'li' ).show();
			}
		} );
	}

	handleIndicatorClick( e ) {
		e.preventDefault();

		if ( ! this.state.isTransitioning ) {
			this.setState( { currentPage: $( e.target ).data( 'page' ) } );
		}
	}

	handleNextClick( e ) {
		e.preventDefault();
		if (
			! this.state.isTransitioning &&
			this.state.currentPage !== this.state.maxPages
		) {
			this.setState( { currentPage: this.state.currentPage + 1 } );
		}
	}

	handlePrevClick( e ) {
		e.preventDefault();

		if ( ! this.state.isTransitioning && this.state.currentPage != 1 ) {
			this.setState( {
				currentPage: this.state.currentPage - 1,
			} );
		}
	}

	handleTransitionStart() {
		this.setState( {
			isTransitioning: true,
		} );
	}

	handleTransitionEnd() {
		this.setState( {
			isTransitioning: false,
		} );
	}

	setPageIndicators() {
		$( this.elements.pageIndicators ).each( ( index, indicator ) => {
			$( indicator ).attr(
				'aria-pressed',
				!! ( index + 1 === this.state.currentPage )
			);
		} );
	}

	goToPage() {
		let translationDistance =
			( this.state.currentPage - 1 ) *
			$( this.elements.galleryViewport ).width() *
			-1;
		$( this.elements.galleryContainer ).css(
			'transform',
			'translateX(' + translationDistance + 'px)'
		);
	}

	render() {
		$( this.elements.next ).attr(
			'disabled',
			!! ( this.state.currentPage === this.state.maxPages )
		);
		$( this.elements.prev ).attr(
			'disabled',
			!! ( this.state.currentPage === 1 )
		);

		$( this.elements.galleryBlock ).toggleClass(
			'single-page',
			this.state.maxPages === 1
		);

		if ( NCST.elements.$win.width() < 576 ) {
			$( this.elements.pageMobileNumeralIndicator ).html(
				this.state.currentPage
			);
		}

		this.goToPage();

		this.setPageIndicators();
	}
}
